module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "ded"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para1"
  }, [_c('a', {
    attrs: {
      "id": "pg_5"
    }
  }, [_c('em', [_vm._v("For Hays Davis")])])]), _c('a', {
    attrs: {
      "id": "pg_5"
    }
  }, [_c('p', {
    staticClass: "dedication"
  }, [_vm._v("Many years (and beers) ago, during one of those all-nighters in which we alternately solved the world’s problems and decided what music belonged on our mix tapes, you made an offhand comment that stuck in my head and led directly to the writing of this book. For two decades’ (and counting) worth of friendship, I dedicate this to you, pal.")])])]), _c('a', {
    attrs: {
      "id": "pg_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a307caa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 72
// module chunks = 0